import { cloneDeep } from 'lodash'

type Timer = ReturnType<typeof setTimeout>

type CachedKeyType = any

type QueueFn = {
  resolve: (fn: ReturnType<typeof getCache>) => void
  reject: (reason?: any) => void
}

type cachedData = Partial<{
  data: any
  timer: Timer | undefined
  startTime: number
  pending: boolean
  queue: QueueFn[]
}>

const cache = new Map<CachedKeyType, cachedData>()

export const setCachePending = (key: CachedKeyType) => {
  cache.set(key, {
    pending: true,
  })
}

const setCacheQueue = (key: CachedKeyType, fn: QueueFn) => {
  const currentCache = cache.get(key)

  cache.set(key, {
    ...(currentCache || {}),
    queue: (currentCache?.queue || []).concat(fn),
  })
}

export const setCacheData = (
  key: CachedKeyType,
  cacheTime: number,
  data: any
) => {
  const currentCache = cache.get(key)
  if (currentCache?.timer) {
    clearTimeout(currentCache.timer)
  }

  let timer: Timer | undefined = undefined
  if (cacheTime > -1) {
    // 数据在不活跃 cacheTime 后，删除掉
    timer = setTimeout(() => {
      removeCache(key)
    }, cacheTime)
  }

  cache.set(key, {
    ...(currentCache || {}),
    pending: false,
    timer,
    data: cloneDeep(data),
    startTime: Date.now(),
  })
}

export const getCache = (key: CachedKeyType) => {
  const currentCache = cache.get(key)
  return {
    ...(currentCache || {}),
    data: cloneDeep(currentCache?.data),
  }
}

export const getCacheByPending = (key: CachedKeyType) => {
  return new Promise((resolve, reject) => {
    const cacheData = getCache(key)
    if (cacheData.startTime) {
      resolve(cacheData)
    } else {
      setCacheQueue(key, {
        resolve,
        reject,
      })
    }
  })
}

export const runCacheQueue = (
  key: CachedKeyType,
  isSuccess: boolean,
  data: any
) => {
  const fns = cache.get(key)?.queue || []
  fns.forEach(fn => (isSuccess ? fn.resolve(cloneDeep(data)) : fn.reject(data)))
  fns.length = 0
}

export const removeCache = (key: CachedKeyType) => {
  cache.delete(key)
}
